import { cva } from 'class-variance-authority';

export const cardVariants = cva('eye:relative eye:rounded-md', {
  variants: {
    variant: {
      default: 'eye:bg-white',
      highlight: 'eye:bg-card-highlight',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
